// Max Bounds
// Top Left Corner (39.1520565, -105.3722563)
// Top Right Corner (39.1573811, -103.9824858)
// Bottom Left (38.4971659, -105.3467172)
// Bottom Right (38.4831923, -103.9926523)

// old values:
//             [-106.236711, 38.110889], // Southwest coordinates
//             [-103.194951, 39.783504]  // Northeast coordinates
//
// Top Left Corner (39.090292, -105.251405)
// Top Right Corner (39.078587 , -104.119832)
// Bottom Left (38.555167 , -105.236864)
// Bottom Right (38.556222 , 104.124483 )

// (-171.791110603, 18.91619, -66.96466, 71.3577635769)

// long, lat
export const MAX_BOUNDS = [
    [-171.791110603, 18.91619], // Southwest coordinates
    [-66.96466, 71.3577635769] // Northeast coordinates
];

// right: 38.865251315172614 -104.02970125562987
// left: 38.92158199130443 -105.342580981931
//
// bottom: 38.51080089350346 -104.48548097423742
// top: 39.14384623775875 -104.55790429486966

export const MAX_BOUNDS_ZOOMED = [
    [-105.342580981931, 38.51080089350346],
    [-104.02970125562987, 39.14384623775875]
]